<script>
    import UsersCollection from '../components/users/UsersCollection.vue';

    export default {
      components: { UsersCollection },
    };
</script>